export default __webpack_public_path__ + "static/ABCtouchfreeleftplate-6a9ce0f885a5bf2552a8897f45d9c0a5.svg";